import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";


const config = {
  apiKey: "AIzaSyCC-YPlVn3CwGStQj4qoZBpHABGbzEck-w",
  authDomain: "recipe-search-app-e3b83.firebaseapp.com",
  databaseURL: "https://recipe-search-app-e3b83.firebaseio.com",
  projectId: "recipe-search-app-e3b83",
  storageBucket: "recipe-search-app-e3b83.appspot.com",
  messagingSenderId: "798164716587",
  appId: "1:798164716587:web:390eec66062a9fc5c9ae6e",
  measurementId: "G-ME0TBM208B"
};

firebase.initializeApp(config);

export default firebase;
